import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { State } from 'app/e-form/model/eform-type';
import { EFormHelper } from 'app/e-form/helper/script/helper';
import { Observable } from 'rxjs';
@Component({
   selector: 'app-date-properties',
   templateUrl: './date-properties.component.html',
   styleUrls: ['./date-properties.component.scss']
})
export class DatePropertiesComponent implements OnInit {
   @Input() eForm: FormGroup;
   @Input() state: State;
   @Input() table: State;
   @Output() sendFocus = new EventEmitter<boolean>();
   helper = new EFormHelper();
   displayDisabled: boolean;
   @Input() eventsStateChild: Observable<void>;

   constructor() { }

   ngOnInit(): void {
      this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
      this.helper.displayDisabledChanges.subscribe((value) => {
         this.displayDisabled = value;
      });
      this.eventsStateChild.subscribe(() => {
         this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
      });
   }

   onTypeChange(type: string) {
      if (type === 'date') {
         this._setOption(this._getValueIfNot('separateDate'), 'separateDate');
         this._setOption(this._getValueIfNot('dateOption'), 'dateOption');
         this._setOption(this._getValueIfNot('dateFormat'), 'dateFormat');
         this._setOption('', 'timeOption');
         this._setOption('', 'timeFormat');
      } else if (type === 'time') {
         this._setOption(this._getValueIfNot('timeOption'), 'timeOption');
         this._setOption(this._getValueIfNot('timeFormat'), 'timeFormat');
         this._setOption('', 'dateOption');
         this._setOption('', 'dateFormat');
         this._setOption('', 'separateDate');
      } else {
         this._setOption(this._getValueIfNot('separateDate'), 'separateDate');
         this._setOption(this._getValueIfNot('dateOption'), 'dateOption');
         this._setOption(this._getValueIfNot('dateFormat'), 'dateFormat');
         this._setOption(this._getValueIfNot('timeOption'), 'timeOption');
         this._setOption(this._getValueIfNot('timeFormat'), 'timeFormat');
      }
   }

   _setOption(value: any, type: string) {
      if(this.table){
         this.helper.getFieldTableAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex).get(type).setValue(value);
         this.helper.getFieldTableAsFormArray(this.eForm, this.state.sectionIndex, this.state.fieldIndex).updateValueAndValidity();
      }else{
         this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex).get(type).setValue(value);
         this.helper.getFieldAsFormArray(this.eForm, this.state.sectionIndex).updateValueAndValidity();
      }

   }

   _getValue(type: string) {
      return  this.table? this.helper.getFieldTableSomeValue(this.eForm, type, this.state.sectionIndex,this.state.fieldIndex,this.state.tableIndex) : this.helper.getFieldSomeValue(this.eForm, type, this.state.sectionIndex, this.state.fieldIndex);
   }

   _getValueIfNot(type: string) {
      const _value = this._getValue(type) === '' || this._getValue(type) === null ? 0 : this._getValue(type);
      return _value;
   }

   _isTypeDateAndDateTime() {
      return this._getValue('type') === 'date' || this._getValue('type') === 'dateTime';
   }

   _isTypeTimeAndDateTime() {
      return this._getValue('type') === 'time' || this._getValue('type') === 'dateTime';
   }

   sendFocusToCreate(focus: boolean) {
      this.sendFocus.emit(focus);
   }

   onChangeSetPlaceholder() {
      var _formGroup:any
      if(this.table){
         _formGroup = this.helper.getFieldTableAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex,this.state.tableIndex);
      }else{
         _formGroup = this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex);
      }


      const _placeholder = _formGroup.controls.placeholder as FormGroup;
      const _getDate = () => {
         let _textDate = '';
         switch (this._getValueIfNot('dateFormat')) {
            case 0: _textDate = 'dd mmmm yyyy'; break;
            case 1: _textDate = 'dd mmm yyyy'; break;
            case 2: _textDate = 'dd mm yyyy'; break;
            case 3: _textDate = 'dd mm yy'; break;
         }
         return _textDate.split(' ').join(_getSymbol());
      };

      const _getSymbol = () => {
         switch (this._getValueIfNot('separateDate')) {
            case 0: return '-';
            case 1: return '/';
            case 2: return ' ';
         }
      };

      const _getTime = () => {
         switch (this._getValueIfNot('timeFormat')) {
            case 0: return 'hh:mm';
            case 1: return 'hh:mm:ss';
            case 2: return 'hh:mm:ss.sss';
         }
      };

      let _text = '';
      switch (this._getValue('type')) {
         case 'date' : _text = _getDate(); break;
         case 'time' : _text = _getTime(); break;
         default : _text = _getDate() + ' ' + _getTime(); break;
      }
       _placeholder.controls['en'].setValue(_text);
       _placeholder.controls['th'].setValue(_text);
   }
}
